module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/sp-h1-title-a6213c1c1db82b7d0308481067d5f26a.png";